import { PkIdentifier } from '@uefadigital/panenka-react';
import { useTranslation } from 'react-i18next';

import type { MatchesInfo } from './utils';

interface StatsOverviewProps {
  homeWin: MatchesInfo;
  draw: MatchesInfo;
  awayWin: MatchesInfo;
  isDesktop: boolean;
  scoreNumber: string;
  scoreTitle: string;
  havePreviousMatches: boolean;
}

const StatsOverview = ({
  homeWin,
  draw,
  awayWin,
  scoreNumber,
  scoreTitle,
  havePreviousMatches,
}: StatsOverviewProps) => {
  const { t } = useTranslation();

  if (!havePreviousMatches) {
    return (
      <div className="pk-mt--0 pk-mt-md--xs">
        <PkIdentifier alignment="center">
          <span slot="secondary" className={scoreTitle}>
            {t('no_previous_matchup')}
          </span>
        </PkIdentifier>
      </div>
    );
  }

  return (
    <div className="pk-mt--0 pk-mt-md--xs pk-px--0 pk-justify-content--between pk-d--flex pr-pl--20p pr-pr--20p">
      <div>
        <PkIdentifier alignment="center">
          <span slot="primary" className={scoreNumber}>
            {homeWin.value}
          </span>
          <span slot="secondary" className={scoreTitle}>
            {homeWin.title}
          </span>
        </PkIdentifier>
      </div>

      <div>
        <PkIdentifier alignment="center">
          <span slot="primary" className={scoreNumber}>
            {draw.value}
          </span>
          <span slot="secondary" className={scoreTitle}>
            {draw.title}
          </span>
        </PkIdentifier>
      </div>

      <div>
        <PkIdentifier alignment="center">
          <span slot="primary" className={scoreNumber}>
            {awayWin.value}
          </span>
          <span slot="secondary" className={scoreTitle}>
            {awayWin.title}
          </span>
        </PkIdentifier>
      </div>
    </div>
  );
};

export default StatsOverview;
